function HealthCheck() {
  return null;
}

export default HealthCheck;
